import { Divider, Empty } from 'antd'
import React, { Fragment } from 'react'
import { StyledDivider } from '../../../../components/UIComponents/FormStyles'
import { FlexWrap } from '../../../ATS/Components/IndividualTable/Style'
import EducationSection from '../../../Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/EducationSection'
import HonorsAwardsSection from '../../../Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/HonorsAwardsSection'
import InfoSection from '../../../Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/InfoSection'
import WorkExperienceSection from '../../../Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/WorkExperienceSection'
import {
  Main,
  MainHeading,
  SubFLex,
} from '../../../Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'

const StudentResumeDrawerContent = ({ previewData }) => {
  return (
    <Main>
      {previewData?.educationProfile?.length ? (
        <Fragment>
          <MainHeading>Educations</MainHeading>
          <EducationSection studentData={previewData} resume={true} />{' '}
          <StyledDivider />
        </Fragment>
      ) : (
        <FlexWrap>
          <Divider>
            <Empty description={<p>No Education Profile Found </p>} />
          </Divider>
        </FlexWrap>
      )}
      {previewData?.resume?.projects?.length ? (
        <Fragment>
          <MainHeading>Project</MainHeading>
          <SubFLex column gap="25px">
            {previewData?.resume?.projects?.map((item, index) => (
              <InfoSection
                resume={true}
                key={index + item?.title}
                name={item?.title}
                company={item?.organization}
                work={item?.description}
                skills={item?.skill_set}
                functionName={item?.function}
                role={item?.role}
                industry={item?.industry}
                duration={`${item?.started_in}- ${item?.ended_in}`}
              />
            ))}
          </SubFLex>
          <StyledDivider />
        </Fragment>
      ) : null}
      {previewData?.resume?.internships?.length ? (
        <Fragment>
          <MainHeading>Internship</MainHeading>
          <SubFLex column gap="25px">
            {previewData?.resume?.internships?.map((item, index) => (
              <InfoSection
                resume={true}
                key={index + item?.title}
                name={item?.title}
                company={item?.organization}
                work={item?.description}
                skills={item?.skill_set}
                functionName={item?.function}
                role={item?.role}
                industry={item?.industry}
                duration={`${item?.started_in}- ${item?.ended_in}`}
              />
            ))}
          </SubFLex>

          <StyledDivider />
        </Fragment>
      ) : null}
      {previewData?.resume?.training?.length ? (
        <Fragment>
          <MainHeading>Training</MainHeading>
          <SubFLex column gap="25px">
            {previewData?.resume?.training?.map((item, index) => (
              <InfoSection
                key={index + item?.title}
                name={item?.title}
                company={item?.organization}
                work={item?.description}
                skills={item?.skill_set}
                duration={`${item?.started_in}- ${item?.ended_in}`}
              />
            ))}
          </SubFLex>

          <StyledDivider />
        </Fragment>
      ) : null}
      {previewData?.resume?.awards?.length ? (
        <Fragment>
          <HonorsAwardsSection awards={previewData?.resume?.awards} />
          <StyledDivider />
        </Fragment>
      ) : null}
      {previewData?.resume?.workExperience?.length ? (
        <Fragment>
          <WorkExperienceSection
            experience={previewData?.resume?.workExperience}
            resume={true}
          />
          <StyledDivider />
        </Fragment>
      ) : null}
      {previewData?.resume?.courses?.length ? (
        <Fragment>
          <MainHeading>Certifications</MainHeading>
          <SubFLex column gap="25px">
            {previewData?.resume?.courses?.map((item, index) => (
              <InfoSection
                resume={true}
                key={index + item?.title}
                name={item?.title}
                company={item?.organisation || item?.organization}
                work={item?.description}
                duration={item?.started_in && item?.ended_in ? `${item?.started_in} - ${item?.ended_in}` : ''}
              />
            ))}
          </SubFLex>
          <StyledDivider />
        </Fragment>
      ) : null}
    </Main>
  )
}

export default StudentResumeDrawerContent
